import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { WhatsNewItem as WhatsNewItemType } from "../model";

interface WhatsNewItemProps {
  item: WhatsNewItemType;
}

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      marginBottom: 16,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "100%",
    },
    imageContainer: {
      marginBottom: 24,
      width: "100%",
      display: "flex",
      justifyContent: "center",
    },
    image: {
      width: "100%",
      maxHeight: 260,
      borderRadius: 4,
    },
    description: {
      textAlign: "center",
      fontFamily: "Neutrif Pro",
      fontSize: 16,
      lineHeight: "20px",
      color: "#0a3566",
      marginBottom: 16,
    },
  })
);

const WhatsNewItem: React.FC<WhatsNewItemProps> = ({ item }) => {
  const classes = useStyles();

  return (
    <Grid item xs={12} className={classes.container}>
      <div className={classes.imageContainer}>
        <img src={item.imageUrl} alt={item.description} className={classes.image} />
      </div>
      <Typography className={classes.description} variant="body1">
        {item.description}
      </Typography>
    </Grid> 
  );
};

export default WhatsNewItem; 